export default __webpack_public_path__ + "static/media/maping-edit.23460005.svg";